import styled from '@emotion/styled';

const Card = styled.div<{ flex?: number; gap: number; hide?: boolean; bg?: string; noBorder?: boolean }>`
    border: ${({ noBorder }) => (noBorder ? 'none' : '1px solid #d8d8d8')};
    border-radius: 8px;
    display: ${({ hide }) => (hide ? 'none' : 'flex')};
    flex: ${({ flex }) => flex ?? 1};
    gap: ${({ gap }) => gap}px;
    flex-direction: column;
    align-items: flex-start;
    padding: 15px 30px 24px 30px;
    min-height: 400px;
    min-width: 400px;
    max-width: 450px;
    overflow: auto;
    justify-content: space-between;
    background-color: ${({ bg }) => bg ?? ''};
`;

export default Card;
